import React, { Fragment, useEffect, useState } from "react";
import { ArrowLeftCircle } from "iconoir-react";
import { useNavigate, useParams } from "react-router-dom";
import { observer, inject } from "mobx-react";
import { toJS } from "mobx";
import moment from "moment";
import FileItem from "./../../components/FileItemComponent/FileItem";
import SkeletonWorkSchedule from "./../../components/Skeleton/SkeletonWorkSchedule";
import { useTheme } from "@mui/material";
import {
  AiOutlineDelete,
  AiOutlineEdit,
  AiOutlineQuestionCircle,
} from "react-icons/ai";
import { message, Modal } from "antd";
import CompanyWorkScheduleUpdate from "./CompanyWorkScheduleUpdate";
import Message from "../../components/common/Message";

const CompanyWorkScheduleDetail = (props) => {
  const { workScheduleStore } = props;
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const { companyWorkId } = useParams();
  const [getDetail, setGetDetail] = useState(false);
  const theme = useTheme();

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        if (getDetail === true) {
          await Promise.all([
            workScheduleStore.getWorkScheduleDetail(companyWorkId),
          ]);
        }
      } catch (err) {
        console.log(err);
      } finally {
        setLoading(false);
        setGetDetail(false);
      }
    })();
  }, [getDetail]);
  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        await Promise.all([
          workScheduleStore.getWorkScheduleDetail(companyWorkId),
        ]);
      } catch (err) {
        console.log(err);
      } finally {
        setLoading(false);
      }
    })();
  }, []);
  const [workScheduleDetail, setWorkScheduleDetail] = useState();
  // toJS(workScheduleStore.workScheduleDetail)
  useEffect(() => {
    setWorkScheduleDetail(toJS(workScheduleStore.workScheduleDetail));
  }, [workScheduleStore.workScheduleDetail]);
  function uppercase(str) {
    var array1 = str?.split(" ");
    var newarray1 = [];

    for (var x = 0; x < array1?.length; x++) {
      newarray1.push(array1[x].charAt(0).toUpperCase() + array1[x].slice(1));
    }
    return newarray1.join(" ");
  }

  const handleDeleteWorkSchedule = async () => {
    try {
      await workScheduleStore.delete(workScheduleDetail.schedule_code);
    } catch (err) {
      console.log(err);
    } finally {
      createMessage("Xóa lịch cơ quan thành công!", true, "success");
      setTimeout(() => {
        navigate(-1);
      }, 2000);
    }
  };
  const [openCompanyWorkScheduleUpdate, setOpenCompanyWorkScheduleUpdate] =
    useState(false);
  const { confirm } = Modal;

  const showConfirmDeleteWorkSchedule = () => {
    confirm({
      title: "Bạn có muốn xóa lịch cơ quan này không?",
      icon: (
        <AiOutlineQuestionCircle
          style={{ color: "red", width: "30px", height: "30px" }}
        />
      ),
      okText: "Đồng ý",
      cancelText: "Không",
      okType: "danger",
      onOk() {
        handleDeleteWorkSchedule();
      },
    });
  };
  const [message, setMessage] = useState("");
  const [openMessage, setOpenMessage] = useState(false);
  const [severity, setSeverity] = useState("");
  const createMessage = (message, openMessage, severity) => {
    setMessage(message);
    setOpenMessage(openMessage);
    setSeverity(severity);
  };
  return (
    <div>
      {loading ? (
        <SkeletonWorkSchedule />
      ) : (
        <>
          <div
            className="flex items-center p-[20px] fixed w-full z-50"
            style={{
              background: theme.background.header,
              color: theme.color.text1,
            }}
          >
            <ArrowLeftCircle
              className=" mt-1 mr-2 cursor-pointer"
              onClick={() => navigate(-1)}
            />
            <div className="font-bold text-[28px] leading-[29px]  ">
              Lịch cơ quan
            </div>
          </div>
          <div className="pt-6 px-5 !pb-[96px]">
            <div className="text-sm ">
              <div className="mb-3.5 mt-12">
                <b>Ngày thực hiện:</b>
                <p>
                  Ngày giao:{" "}
                  {moment(workScheduleDetail?.start_at).format("DD-MM-YYYY")}
                </p>
              </div>
              <div className="mb-3.5">
                <b>Thời gian:</b>
                {workScheduleDetail?.end_at === null ? (
                  <p>
                    Bắt đầu từ{" "}
                    {moment(workScheduleDetail?.start_at).format("LT")}
                  </p>
                ) : (
                  <p>
                    Bắt đầu từ{" "}
                    {moment(workScheduleDetail?.start_at).format("LT")} tới{" "}
                    {moment(workScheduleDetail?.end_at).format("LT")}
                  </p>
                )}
              </div>
              <div className="mb-3.5">
                <b>Chủ trì:</b>
                <p>{workScheduleDetail?.host}</p>
              </div>
              <div className="mb-3.5">
                <b>Địa điểm:</b>
                <p>
                  {workScheduleDetail.location?.indexOf("http") !== -1 ? (
                    <div>
                      {workScheduleDetail.location?.slice(
                        0,
                        workScheduleDetail.location?.indexOf("http")
                      )}{" "}
                      <a
                        rel="noreferrer"
                        href={workScheduleDetail.location?.slice(
                          workScheduleDetail.location?.indexOf("http")
                        )}
                        target="_blank"
                      >
                        {workScheduleDetail.location?.slice(
                          workScheduleDetail.location?.indexOf("http")
                        )}
                      </a>
                    </div>
                  ) : (
                    <div>{workScheduleDetail.location}</div>
                  )}
                </p>
              </div>
              <div className="mb-3.5">
                <b>Chuẩn bị:</b>
                <p>
                  {workScheduleDetail?.preparation ? (
                    <Fragment>{workScheduleDetail?.preparation}</Fragment>
                  ) : (
                    <i className="text-[#9F9F9F]">Không có.</i>
                  )}
                </p>
              </div>
              <div className="mb-3.5">
                <b>Nội dung sự kiện:</b>
                <p>
                  {workScheduleDetail.event_notice ? (
                    <p
                      dangerouslySetInnerHTML={{
                        __html: workScheduleDetail?.event_notice,
                      }}
                    />
                  ) : (
                    <i className="text-[#9F9F9F]">Không có.</i>
                  )}
                </p>
              </div>
              <div className="mb-3.5">
                <b>Tài liệu đính kèm:</b>
                <p>
                  {workScheduleDetail.file_ids?.length > 0 ? (
                    <Fragment>
                      {workScheduleDetail.file_ids.map((file) => {
                        let file_id = file.file_id;
                        let file_title = file.file_title;
                        let index = file.file_type?.indexOf("/") + 1;
                        let file_type = file.file_type?.slice(index);
                        return (
                          <FileItem
                            file_id={file_id}
                            file_name={file_title}
                            file_type={file_type}
                          />
                        );
                      })}
                    </Fragment>
                  ) : (
                    <i className="text-[#9F9F9F]">Không có.</i>
                  )}
                </p>
              </div>
              <div className="mb-3.5">
                <b>Thành viên tham gia:</b>
                <p>
                  {workScheduleDetail.attenders ? (
                    <Fragment>
                      {uppercase(workScheduleDetail.attenders?.toLowerCase())}
                    </Fragment>
                  ) : (
                    <i className="text-[#9F9F9F]">Không có.</i>
                  )}
                </p>
              </div>
              <div className="mb-3.5">
                <b>Thông báo:</b>
                <p className="flex flex-wrap gap-3">
                  {workScheduleDetail.assignees?.length > 1 ? (
                    <Fragment>
                      {workScheduleDetail.assignees?.map((item, index) => {
                        return (
                          <Fragment>
                            {item.permission === "VIEW" ? (
                              <div
                                key={index}
                                className="mr-2"
                                style={{
                                  padding: "5px",
                                  margin: "2px 0",
                                  border: "1px solid #2c65ac",
                                  borderRadius: "10px",
                                  background: theme.background.rgba1,
                                  color: theme.color.primary,
                                }}
                              >
                                {uppercase(item.name_uppercase?.toLowerCase())}
                              </div>
                            ) : (
                              ""
                            )}
                          </Fragment>
                        );
                      })}
                    </Fragment>
                  ) : (
                    <i className="text-[#9F9F9F]">Không có.</i>
                  )}
                </p>
              </div>
              <div className="mb-3.5">
                <b>Ngày tạo:</b>
                <p className="flex">
                  {workScheduleDetail.assignees?.map((item, index) => {
                    return (
                      <Fragment>
                        {item.permission === "CREATE" ? (
                          <div key={index} className="mr-2">
                            {uppercase(item.name_uppercase?.toLowerCase())}{" "}
                            {moment(workScheduleDetail?.created_at).format(
                              "DD-MM-YYYY LT"
                            )}
                          </div>
                        ) : (
                          ""
                        )}
                      </Fragment>
                    );
                  })}
                </p>
              </div>
              <div className="mb-3.5">
                <b>Chỉnh sửa lần cuối:</b>
                <p>
                  {workScheduleDetail.last_edit_by ? (
                    <Fragment>
                      {uppercase(
                        workScheduleDetail.last_edit_by?.name_uppercase?.toLowerCase()
                      )}{" "}
                      {moment(workScheduleDetail?.updated_at).format(
                        "DD-MM-YYYY LT"
                      )}
                    </Fragment>
                  ) : (
                    <i className="text-[#9F9F9F]">Không có.</i>
                  )}
                </p>
              </div>
            </div>
          </div>
        </>
      )}
      <footer
        style={{
          position: "fixed",
          bottom: 0,
          backgroundColor: "white",
          borderTopRightRadius: "10px",
          borderTopLeftRadius: "10px",
        }}
        className="flex items-center justify-between px-5 w-full py-4 shadow-[0px_0px_8px_rgba(0,0,0,0.25)] "
      >
        <div className="flex justify-between  w-full h-full">
          <div className="block text-center w-[70px]">
            <div
              className="hover:bg-cyan-400 inline-block bg-[rgba(0,115,199,0.07);] text-blue-500 hover:text-white py-[8px] text-center px-[8px] rounded-full text-sm font-medium"
              onClick={() => {
                setOpenCompanyWorkScheduleUpdate(true);
              }}
            >
              <AiOutlineEdit style={{ width: "20px", height: "20px" }} />
            </div>
            <div style={{ fontSize: "11px" }}>Sửa</div>
          </div>
          <div className="block text-center w-[70px]">
            <div
              className="hover:bg-cyan-400 inline-block bg-[rgba(0,115,199,0.07);] text-red-500 hover:text-white py-[8px] text-center px-[8px] rounded-full text-sm font-medium"
              onClick={() => showConfirmDeleteWorkSchedule()}
            >
              <AiOutlineDelete style={{ width: "20px", height: "20px" }} />
            </div>
            <div style={{ fontSize: "11px" }}>Xóa</div>
          </div>
        </div>
      </footer>
      <CompanyWorkScheduleUpdate
        setGetDetail={setGetDetail}
        createMessage={createMessage}
        workScheduleDetail={workScheduleDetail}
        open={openCompanyWorkScheduleUpdate}
        handleClose={() => setOpenCompanyWorkScheduleUpdate(false)}
      />
      <Message
        message={message}
        openMessage={openMessage}
        severity={severity}
        closeMessage={() => {
          setOpenMessage(false);
        }}
      />
    </div>
  );
};

export default inject("workScheduleStore")(observer(CompanyWorkScheduleDetail));
